import script from "./PlatformaSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformaSelect.vue?vue&type=script&setup=true&lang=js"

import "./PlatformaSelect.vue?vue&type=style&index=0&id=7ee5b618&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee5b618"]])

export default __exports__